module.exports = __webpack_public_path__ + "img/2fd8f307aae343ee83655bd60995fcc0.fac80881.png";